<template>
  <div>
    <div
      v-if="error"
      class="row error-container content m-0"
    > 
      <div
        class="error-text-container"
      >
        <p class="error-title color-primary">Ooops!</p>
        <p class="error-text">{{ error.message }}</p>
        <a href="/" class="d-flex justify-content-center">
          <div class="error-button text-white full">Voltar</div>
        </a>
      </div>
    </div>
    <div
      v-else
    >
      <slot></slot>
    </div>
  </div>
</template>

<script>
import Vue from "vue/dist/vue.esm"

export default {
  data: () => ({
    error: false
  }),

  mounted() {
    Vue.config.errorHandler = (err, vm, info) => {
      this.error = err;
    };
  }
};
</script>

<style scoped>
.error-container {
  background: linear-gradient(180deg, rgb(220, 220, 220) 60%, rgba(141,99,240,1) 90%, rgba(25,157,240,1) 150%);
  height: 100%;
  min-height: 100vh;
  padding-bottom: 7em;
  color: #5a595a;
}

.error-text-container {
  margin-top: auto;
  margin-bottom: auto;
  font-weight: bold;
  font-size: 2rem !important;
}

.error-title {
  font-size: 5rem;
}

.error-text {
  color: rgba(93, 61, 125, 0.788);
  font-size: 2rem;
}

.content {
  margin-top: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.content .code {
  font-size: 6rem;
}

.content .message {
  font-size: 4rem;
}

.error-button {
  background-color: #56307b;
  max-width: 300px;
  padding: 10px 10px;
  font-size: 25px;
  border-radius: 5px !important;
}

@media only screen and (max-width: 800px) {
  .content .code {
    font-size: 3rem;
  }

  .content .message {
    font-size: 2rem;
  }
}
</style>
